import React, { ReactElement } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useRouter } from 'next/router';
import Headline2 from '@fuww/library/src/Typography/Heading/Headline2';
import Head from '../components/Head';
import messages from '../lib/messages.mjs';
import Markdown from '../components/Markdown';
import statisticPages from '../lib/statisticPagesConfig';
import StatisticLayout from '../components/StatisticPage/Layout';
import HomeLink from '../components/HomeLink';
import LinkAndAnchor from '../components/LinkAndAnchor';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const StatisticPageDisclaimer = ({ intl }: { intl: IntlShape }) => (
  <>
    <Headline2>{intl.formatMessage(messages['statistic.sources'])}</Headline2>
    {/* eslint-disable-next-line react/no-danger */}
    <div dangerouslySetInnerHTML={{
      __html: intl.formatMessage(messages['statistic.disclaimer']),
    }}
    />
  </>
);

const StatisticPage = () => {
  const intl = useIntl();
  const { query } = useRouter();
  const slug = String(query.slug);
  const pageData = statisticPages[slug];

  const { title, markdown } = pageData;

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="statistics"
      passHref
    >
      {intl.formatMessage(messages.statistics)}
    </LinkAndAnchor>,
    title,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(
          messages['statistic.title'],
        )}
        description={intl.formatMessage(
          messages['statistic.description'],
        )}
      />
      <StaticPageComponent
        breadcrumbs={breadcrumbs}
        content={(
          <>
            <Markdown markdown={markdown} allowHtml allowGfm />
            <StatisticPageDisclaimer intl={intl} />
          </>
        )}
        title={title}
        subTitle={intl.formatMessage(
          messages['statistic.subTitle'],
        )}
        withTableStyles
      />
    </>
  );
};

StatisticPage.getLayout = (page: ReactElement) => (
  <StatisticLayout>{page}</StatisticLayout>
);

StatisticPage.getInitialProps = redirectRouteToDomain('statistic');

export default StatisticPage;
